import { WebToAppModal } from './WebToAppModal';

export const WebToAppBottomSheet = ({
  close,
  onTodayNoShowClick,
}: {
  close: () => void;
  onTodayNoShowClick: () => void;
}) => {
  return <WebToAppModal close={close} onTodayNoShowClick={onTodayNoShowClick} />;
};
